import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Formik } from 'formik';
import * as Yup from 'yup';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { bindActionCreators } from 'redux';

import { closeModal, changeTypeOfModal } from '../../../actions/modals';

import './styles/modalWidgetForm.scss';

const schema = Yup.object().shape({
  name: Yup.string().required('Обязательное поле'),
  phone: Yup.string().required('Обязательное поле').min(16, 'Некорректный номер телефона'),
  club_id: Yup.number().required('Обязательное поле'),
});

class ModalWidgetForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startScreen: true,
      submitScreen: false,
      successScreen: false,
      errorScreen: false,
      discount: null,
      present: null,
      clubOptions: [],
      spinning: false,
      stopping: false,
      presentId: null,
      presentExist: false,
      deg: 0,
    };
  }

  componentDidMount() {
    this.setClubOptions();
  }

  componentWillUnmount() {
    this.setCookieLastShow();
  }

  completedSuccessSend() {
    this.props.closeModal();
    this.props.changeTypeOfModal(null);
  }

  handleSubmit(values, actions) {
    this.setState({
      submitScreen: true,
      spinning: true,
    });

    document.getElementById("start-screen-image").scrollIntoView({
      behavior: "smooth", // Smooth transition animation
      block: "center",     // Vertical alignment: 'start', 'center', 'end', or 'nearest'
      inline: "nearest"   // Horizontal alignment: 'start', 'center', 'end', or 'nearest'
    });

    actions.setSubmitting(true);

    let data = {
      widget_slug: this.props.modalInfo.widgetSlug,
      name: values.name,
      phone: values.phone,
      club_id: values.club_id,
      cookie: JSON.stringify(Cookies.get()),
      utm: window.location.search.slice(1) || '',
      referer: document.referrer,
      roistat_visit: Cookies.get('roistat_visit'),
      agreements: {
        personal_data_policy_user_agreement: values.agreement,
        contact_with_call_or_sms: values.call_consent,
      }
    };

    const sendURL = `${process.env.REACT_APP_API_SITE}/widgets/${this.props.modalInfo.widgetSlug}`;
    const self = this;

    axios
        .post(sendURL, data)
        .then(async (response) => {
          if (response.status === 200) {
            self.setState({
              discount: response.data?.data?.discount ?? null,
              present: response.data?.data?.present ?? null,
              presentId: response.data?.data?.id ?? null,
              presentExist: !(response.data?.data?.discount_saved ?? true),
            }, async () => {
              if(self.props.modalInfo.widgetType === 'wheel-rotation')
                await self.handleRotation();

              this.setState({
                startScreen: false,
                submitScreen: false,
                successScreen: true,
                spinning: false,
              });
              actions.setSubmitting(false);
              actions.resetForm();
              self.setCookiePassed();
            });
          }
        })
        .catch(function (error) {
          actions.setSubmitting(false);
          self.setState({
            submitScreen: false,
            startScreen: false,
            errorScreen: true,
            spinning: false,
          });
        })
  }

  async handleRotation() {
    const image = document.getElementById('start-screen-image');
    const style = window.getComputedStyle(image);
    const matrix = new DOMMatrix(style.transform);
    let currentAngle = Math.round(Math.atan2(matrix.b, matrix.a) * (180 / Math.PI));

    if (currentAngle < 0) {
      currentAngle += 360;
    }

    let targetAngle = 0;
    if(this.state.presentExist === false) {
      const winningIndex = this.props.modalInfo.discounts.findIndex(s => s.id === this.state.presentId);
      const numSectors = this.props.modalInfo.discounts.length;
      const totalNumSectors = this.props.modalInfo.totalWheelSectorAmount;
      const sectorAngleDeg = 360 / totalNumSectors;

      // базовый угол для перемещения лепестка наверх (0 градусов) и добавляем 90 градусов (указатель справа)
      const currentIndex = winningIndex * totalNumSectors/numSectors;
      targetAngle = (totalNumSectors - currentIndex) * sectorAngleDeg + 90;
    }

    let diffAngle = targetAngle - (currentAngle % 360);

    if (diffAngle <= 0) {
      diffAngle += 360;
    }

    const extraSpins = 2;
    const finalAngle = currentAngle + (extraSpins * 360) + diffAngle;

    this.setState({
      deg: finalAngle,
      spinning: false,
      stopping: true,
    });

    image.style.animation = 'none';

    const duration = 3000; // Время торможения 3 секунды
    const startTime = performance.now();

    // Запуск цикла анимации
    requestAnimationFrame(function animate(time) {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Вычисляем текущий угол на основе кривой плавности
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      const currentAnimationAngle = currentAngle + (finalAngle - currentAngle) * easeProgress;

      image.style.transform = `rotate(${currentAnimationAngle}deg)`;

      if (progress < 1) {
        // Если время не вышло, продолжаем крутить на следующем кадре
        requestAnimationFrame(animate);
      }
    });

    // Ожидание окончания анимации (3 секунды)
    await new Promise(resolve => setTimeout(resolve, 3000));
    this.setState({
      stopping: false,
    });
  }

  setCookiePassed() {
    let currentDate = new Date();
    let expireDate = this.props.modalInfo.widgetActiveUntil ? new Date(this.props.modalInfo.widgetActiveUntil) :  new Date((new Date()).setMonth(currentDate.getMonth() + 1));
    let expireDays = Math.round((expireDate.getTime() - currentDate.getTime()) /  (1000 * 60 * 60 * 24));
    Cookies.set(`widget_${this.props.modalInfo.widgetSlug}_passed`, currentDate.getTime(), { expires: expireDays });
  }

  setCookieLastShow() {
    let currentDate = new Date();
    let expireDate = this.props.modalInfo.widgetActiveUntil ? new Date(this.props.modalInfo.widgetActiveUntil) : new Date((new Date()).setMonth(currentDate.getMonth() + 1));
    let expireDays = Math.round((expireDate.getTime() - currentDate.getTime()) /  (1000 * 60 * 60 * 24));
    Cookies.set(`widget_${this.props.modalInfo.widgetSlug}_last_show`, currentDate.getTime(), { expires: expireDays });
  }

  handleSubmitAgain() {
    this.setState({
      submitScreen: false,
      startScreen: true,
      errorScreen: false,
      successScreen: false,
    });
  }

  setClubOptions() {
    let self = this;
    axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_SITE}/clubs/select-list`,
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      if(response.data.data && response.data.data.length) {
        self.setState({
          clubOptions: response.data.data
        });
      }
    }).catch(function (error) {
      self.setState({
        clubOptions: []
      });
    });
  }

  render() {
    let { 
      title,
      text,
      buttonCaption, 
      image,
      successTitle, 
      successText, 
      successImage,
      failTitle, 
      failText,
      widgetType,
      discounts,
      winPresentLabel,
      winPresentLabelPlace,
      winExistsTitle
     } = this.props.modalInfo;

    return (
        <div className="modalWidgetForm">
          <div className={`modalWidgetForm__start ${!this.state.startScreen && '_hidden'} ${this.state.submitScreen ? '_submitting' : ''}`}>
            <div className={`modalWidgetForm__formTitle`}>
              {
                title && <div className="modalWidgetForm__title" dangerouslySetInnerHTML={{ __html: title }}></div>
              }
            </div>
              {
                text && <div className={`modalWidgetForm__formText`} dangerouslySetInnerHTML={{__html: text}}></div>
              }
            <div className="modalWidgetForm__formBlock">
              <Formik
                  initialValues={{
                    name: '',
                    phone: '',
                    club_id: '',
                    agreement: false,
                    call_consent: false,
                  }}
                  validationSchema={schema}
                  onSubmit={(values, actions) => {
                    this.handleSubmit(values, actions);
                  }}
              >
                {(props) => (
                    <form onSubmit={props.handleSubmit} className="modalWidgetForm__field">
                      <div className="modalWidgetForm__field__two-columns">
                        <div className="form-group">
                          <label htmlFor="name-field">Ваше имя</label>
                          <input
                              id="name-field"
                              type="text"
                              onChange={props.handleChange}
                              onBlur={props.handleBlur}
                              value={props.values.name}
                              name="name"
                              placeholder="Имя"
                              autoComplete="off"
                              className={`
                            ${props.touched.name && props.errors.name && '_error-field'}
                            ${props.touched.name && !props.errors.name && '_valid'}
                        `}
                          />
                          {props.touched.name && props.errors.name && (
                              <span className="error-field">{props.errors.name}</span>
                          )}
                        </div>
                        <div className="form-group">
                          <label htmlFor="phone-field">Телефон</label>
                          <InputMask
                              type="text"
                              onChange={props.handleChange}
                              onBlur={props.handleBlur}
                              name="phone"
                              id="phone-field"
                              autoComplete="off"
                              mask="+7 ( 999 ) 999 99 99"
                              placeholder="+7 ( ___ )  ___  ___  ___"
                              maskChar=""
                              value={props.values.phone}
                              className={`
                                ${props.touched.phone && props.errors.phone && '_error-field'}
                                ${props.touched.phone && !props.errors.phone && '_valid'}
                            `}
                          />
                          {props.touched.phone && props.errors.phone && (
                              <span className="error-field">{props.errors.phone}</span>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="club-field">Клуб для посещения</label>
                        <Select
                            options={this.state.clubOptions}
                            name="club-field"
                            //    value={clubOptions ? clubOptions.find(option => option.value === props.values.club) : ''}
                            onChange={option => {
                              props.setFieldValue('club_id', option.value)
                            }}
                            onBlur={props.handleBlur}
                            className={`react-select-container
                                  ${props.touched.club_id && props.errors.club_id && '_error-field'}
                                  ${props.touched.club_id && !props.errors.club_id && '_valid'}
                                  `}
                            classNamePrefix="react-select"
                            placeholder="Выберите адрес"
                            isSearchable={false}
                            formatOptionLabel={function (data) {
                              return (
                                  <span dangerouslySetInnerHTML={{__html: data.label}}/>
                              );
                            }}
                        />
                          {props.touched.club_id && props.errors.club_id && (
                              <span className="error-field">{props.errors.club_id}</span>
                          )}
                      </div>
                      <div className="modalWidgetForm__checkboxes">
                        <div className="agreement-checkbox">
                          <input type="checkbox" id="agreement" name="agreement" className="form-check" onChange={props.handleChange} checked={props.values.agreement} required/>
                          <label htmlFor="agreement">Нажимая на кнопку, Вы даёте <a href="{" rel="nofollow noopener" target="_blank">согласие на обработку персональных данных</a>,
                            а&nbsp;также соглашаетесь c <a href="{" rel="noopener noreferrer" target="_blank">политикой обработки персональных данных</a>
                            и <a href="{" rel="noopener noreferrer" target="_blank">пользовательским соглашением</a>.
                          </label>
                        </div>
                        <div className="agreement-checkbox">
                          <input type="checkbox" id="call_consent" name="call_consent" className="form-check" onChange={props.handleChange} checked={props.values.policy} />
                          <label htmlFor="call_consent">Даю согласие и разрешение связаться со мной по&nbsp;телефону, с&nbsp;помощью СМС или&nbsp;e-mail.
                          </label>
                        </div>
                      </div>
                      <div className="modalWidgetForm__submit_btn">
                        <button type="submit" className="modalWidgetForm-btn" disabled={props.isSubmitting}>
                          <span>{buttonCaption}</span>
                        </button>
                      </div>
                    </form>
                )}
              </Formik>
            </div>
            <div className={`modalWidgetForm__decorBlock`}>
              {
                widgetType === 'wheel-rotation' && (
                    <div className="arrow_container">
                      <div className="arrow"></div>
                    </div> )
              }
              <div className="modalWidgetForm__decor_wheel">
                <div id="start-screen-image" style={{ backgroundImage: `url('${image}')`}}
                     className={`modalWidgetForm__decor_image ${widgetType ? '_' + widgetType : ''} ${this.state.submitScreen ? '_submitting' : ''} ${this.state.stopping ? '_stopping' : ''} ${this.state.spinning ? '_spinning' : ''}`}>
                  {
                    widgetType === 'wheel-rotation' && discounts.map((discount, index) => {
                      let petalAngle = index * 360/discounts.length;
                      return (<div
                              key={discount.id}
                              className="discount-segment"
                              style={{transform: `rotate(${petalAngle}deg)`}}>
                            <span className="discount-segment_value">{discount.discount ? discount.discount + '%' : discount.present}</span>
                          </div>
                      );
                    })
                  }
                </div>
              </div>
            </div>
          </div>
          <div className={`modalWidgetForm__success ${this.state.successScreen && '_active'} ${this.state.presentExist && winExistsTitle && '_exists'}`}>
            {
              this.state.presentExist && winExistsTitle ?
                  <>
                    <p className="modalWidgetForm__success__title _exists">{winExistsTitle}</p>
                    <button className="modalWidgetForm-btn" onClick={this.completedSuccessSend.bind(this)}>
                      <span>Закрыть</span>
                    </button>
                  </>
                  : (
                      <>
                        <div className="modalWidgetForm__success__title">
                          {
                            successTitle && <p>{successTitle}</p>
                          }
                          {
                            winPresentLabel && winPresentLabelPlace === 'title' &&
                            <p>{`${winPresentLabel} ${this.state.discount ?? this.state.present}`}</p>
                          }
                        </div>
                        {
                          successText && <p className="modalWidgetForm__success__text"
                                            dangerouslySetInnerHTML={{__html: successText}}></p>
                        }
                        <button className="modalWidgetForm-btn" onClick={this.completedSuccessSend.bind(this)}>
                          <span>Хорошо</span>
                        </button>
                      </>
                  )
            }
            <div className={`modalWidgetForm__decorBlock`}>
              {
                widgetType === 'wheel-rotation' && (
                    <div className="arrow_container">
                      <div className="arrow"></div>
                    </div>
                )
              }
              <div style={{backgroundImage: successImage ? `url('${successImage}')` : `url('${image}')`, transform: widgetType === 'wheel-rotation' ? `rotate(${this.state.deg}deg)` : 'none',}}
                   className="modalWidgetForm__decor_image">
                {
                  widgetType === 'wheel-rotation' ? discounts.map((discount, index) => {
                    let petalAngle = index * 360/discounts.length;
                    return (<div
                            key={discount.id}
                            className="discount-segment"
                            style={{transform: `rotate(${petalAngle}deg)`}}>
                          <span
                              className="discount-segment_value">{discount.discount ? discount.discount + '%' : discount.present}</span>
                        </div>
                    );
                  }) : (
                      this.state.discount ? (
                          <div className="discount-value">
                            <p className="discount-value__title">Ваша скидка</p>
                            <p className="discount-value__value">{this.state.discount}</p>
                          </div>
                      ) : this.state.present ? (
                          <div className="present-value">
                            <p className="present-value__title">Ваш подарок</p>
                            <p className="present-value__value">{this.state.present}</p>
                          </div>
                      ) : ''
                  )
                }
              </div>
            </div>
          </div>
          <div className={`modalWidgetForm__error ${this.state.errorScreen && '_active'}`}>
            <div className="modalWidgetForm__error__text">
              <p className="title-answer">{failTitle}</p>
              <p dangerouslySetInnerHTML={{__html: failText}}></p>
              <button className="btn btn--blue" onClick={this.handleSubmitAgain.bind(this)}>
                <span>Отправить еще</span>
              </button>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.documents,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal,
  changeTypeOfModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ModalWidgetForm);